import { KING, TYPE_MASK, WHITE, crowning, heirsOf, isAction, pieceDef } from '@chessbut/engine';
import type { Decoration, VariantUi } from './ui.ts';

const CROWN = '/art/crown.svg';

export const heirUi: VariantUi = {
  heroImage: CROWN,
  peek: [{}, { image: '/art/bK.svg', threat: true }, {}, {}, { image: '/art/wR.svg' }, {}, {}, { image: CROWN }, {}],

  // Crowning is a tap on the piece itself.
  boardAction: () => true,

  decorations(pos) {
    const out: Decoration[] = [];
    for (const c of [0, 1] as const) {
      const r = pos.royals[c];
      if (r >= 0 && (pos.board[r] & TYPE_MASK) !== KING) out.push({ kind: 'badge', sq: r, text: '👑', tone: 'normal' });
    }
    if (crowning(pos)) for (const sq of heirsOf(pos, pos.turn)) out.push({ kind: 'mark', sq, tone: 'info' });
    return out;
  },

  pieceLabel(pos, sq, piece) {
    const r = pos.royals[piece & 32 ? 0 : 1];
    if (r !== sq || (piece & TYPE_MASK) === KING) return null;
    return `${piece & 32 ? 'white' : 'black'} ${pieceDef(piece & TYPE_MASK).name}, crowned king`;
  },

  twist(pos, you) {
    const mine = you === null || pos.turn === you;
    if (crowning(pos)) {
      return mine ? { text: 'Your king has fallen! Tap a piece to crown it.', alert: true } : { text: 'Their king has fallen. They’re choosing an heir…' };
    }
    const side = you ?? pos.turn;
    const heirs = heirsOf(pos, side).length;
    const who = you === null ? (side === WHITE ? 'White has' : 'Black has') : 'You have';
    return {
      text: `No check here: capture the king. ${who} ${heirs} heir${heirs === 1 ? '' : 's'} left.`,
      pips: { on: Math.min(heirs, 7), total: 7, title: 'Pieces that could take the crown' },
      alert: heirs <= 1,
    };
  },

  eventSound(e) {
    if (e.t !== 'fx') return null;
    return e.kind === 'crown' ? 'levelup' : e.kind === 'regicide' ? 'boom' : null;
  },

  moveBadge(rec) {
    if (isAction(rec.move)) return { icon: CROWN, title: 'A new king is crowned' };
    if ((rec.captured & TYPE_MASK) === KING || rec.events.some((e) => e.t === 'fx' && e.kind === 'regicide')) {
      return { icon: CROWN, victim: rec.captured || undefined, title: 'The king was captured' };
    }
    return null;
  },
};
